<section fxLayout="column" fxFlexAlign="stretch">
  <div fxFlexAlign="center">
    <p>{{title}}</p>
  </div>
  <mat-card *ngIf="!tests" class="textAlignCenter">
    Loading ...
  </mat-card>

  <mat-card *ngIf="tests" class="textAlignCenter">
    <div *ngFor="let test of tests; let i = index">
      <button mat-raised-button color="basic" class="question-selector-button {{i != 0 ? 'margin-top-20-important' : ''}}"
              routerLink="/test/{{test.uniqueIdentifier}}">
        {{test.title}}
      </button>
    </div>
  </mat-card>

</section>
